import axios from "axios";

const axiosInstance = axios.create({
  withCredentials: true, // ✅ Ensures JWT cookies are sent automatically
  headers: { "Content-Type": "application/json" },
});

// ✅ Request Interceptor: Logs Requests
axiosInstance.interceptors.request.use(
  (config) => {
    console.debug("🔍 [AXIOS] Request:", {
      method: config.method.toUpperCase(),
      url: config.url,
      headers: config.headers,
    });
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor: Handles Errors & Logging
axiosInstance.interceptors.response.use(
  (response) => response, // ✅ Pass successful responses as is
  (error) => {
    if (error.response) {
      console.error("❌ [AXIOS] API Error:", {
        status: error.response.status,
        data: error.response.data,
      });
    } else {
      console.error("❌ [AXIOS] Network Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
